import './SkeletonCard.css'
const SkeletonCard = () => {
  return (
    <article className="bg-slate-100 skeleton-card w-full flex flex-row text-left justify-between px-10 py-4 mb-10 h-[200px] rounded-2xl">
      <div className="flex flex-col tex-base w-1/6 h-full">
        <div className="skeleton-card__author w-full h-8 mb-4"></div>
        <div className="skeleton-card__publication w-full h-4"></div>
      </div>
      <div className="flex flex-col items-start w-1/2 h-full">
        <div className="skeleton-card__title w-full h-8 mb-4"></div>
        <div className="skeleton-card__abstract w-full h-24"></div>
      </div>
      <div></div>
    </article>
  );
};

export default SkeletonCard;